module.exports = __webpack_public_path__ + "img/roads-04a005e.png";